var lazy;

function Main() {
    this.init();
}

Main.prototype = {
    constructor: Main,
    initPlugins: function (scope) {
        var _t = this;

        // LAZYLOAD
        lazy = new LazyLoad({
            elements_selector: '.lazy',
            callback_reveal: function (elm) {
                if (elm.tagName != 'IMG' && elm.hasAttribute('data-bg'))
                    elm.classList.add('bg-loaded');
            }
        });
        
    // JS Triggers
        // config.js
        SITE_CONFIG.general.preloader = '<div class="preloader-inline">' + document.querySelector('.preloader').innerHTML + '</div>';
        SITE_CONFIG.general.url = document.querySelector('link[rel=canonical]') && document.querySelector('link[rel=canonical]').href || window.location.href;


        // events.js
        events.init();
        // custom-menu.js
        //customMenu.init();
        //customPopup.init();
        // multipleProductImage
        //multipleProductImage.init();
        // compare.js
        //compare.init();
        // customSearch.js
        //customSearch.init();
        //supportSearch.init();
        // loginWizard.js
        //loginWizard.init();
        // promotion.js
        /*(function () {
            promotion();
        }());*/
        
        // targetElement.js
        //targetElement.init(); nerede kullanıldığını bulamadım.

        // Accordion.js
        //accordion.init();
        // filter.js
        //PLPfilter.init();
        //loadAssistant.init();
        //PLPassistant.init();
        //PLPcouponCounter.init();
        // pdp.js
        //pdpControls.init();
        // purchase.js
        //purchaseControls.init();
        // countdownCustom.js
        //dealCountdown.init();
        // cleaveCustom.js
        //inputMask.init();
        // customMap.js
        // storesAvaiblableDelivery.init();
        // stores.init();
        // share.js
        //customShare.init();
        //imageMap.init();

        //_t.methods.assistant.init();

        window.addEventListener('load', function() {
            $.cachedScript(extJSPath + 'all-other.js').done(function(s, r) {
                if(r == 'success'){
                    customShare.init();
                }
            });

            if(utils.detectEl($('.swiper-multiple-product-image')[0])){
                $.cachedScript(extJSPath + 'components/multipleProductImage.js').done(function(s, r) {
                    if(r == 'success'){
                        multipleProductImage.init();
                    }
                });
            }

            if(utils.detectEl($('.compare-info')[0]) || utils.detectEl($('.page-compare')[0])){
                $.cachedScript(extJSPath + 'components/compare.js').done(function(s, r) {
                    if(r == 'success'){
                        compare.init();
                    }
                });
            }

            if(utils.detectEl($('.spt-search')[0])){
                $.cachedScript(extJSPath + 'components/search/supportSearch.js').done(function(script, textStatus) {
                    if(textStatus == 'success'){
                        supportSearchFN.init();
                    }
                });
            }

            if(utils.detectEl($('.password [type="password"]')[0]) || utils.detectEl($('[data-selector="email-phone"]'))) {
                $.cachedScript(extJSPath + 'components/loginWizard.js').done(function(s, r) {
                    if(r == 'success'){
                        loginWizardFN.init();
                    }
                });
            }

            if(utils.detectEl($('.promo-holder')[0])){
                $.cachedScript(extJSPath + 'components/promotion.js').done(function(s, r) {
                    if(r == 'success'){
                        $('.promo-holder').each(function(){
                            promotionFN.init($(this));
                        });
                    }
                });
            }

            if(utils.detectEl($('.accordion')[0])){
                $.cachedScript(extJSPath + 'components/accordion.js').done(function(s, r) {
                    if(r == 'success'){
                        accordion.init();
                    }
                });
            }

            if(utils.detectEl($('#modal-filters')[0])){
                $.cachedScript(extJSPath + 'components/filter/PLPfilter.js').done(function(script, textStatus) {
                    if(textStatus == 'success'){
                        PLPfilterFN.init();
                    }
                });
            }

            if(utils.detectEl($('.assistant')[0]) || utils.detectEl($('#assistant')[0]) || utils.detectEl($('#modal-assistant')[0])){
                $.cachedScript(extJSPath + 'components/assistant.js').done(function(script, textStatus) {
                    if(textStatus == 'success'){
                        PLPassistant.init();
                        assistantStart.init();
                    }
                });
            }

            if(utils.detectEl($('#coupon-counter')[0])){
                $.cachedScript(extJSPath + 'components/filter/PLPcouponCounter.js').done(function(s, r) {
                    if(r == 'success'){
                        PLPcouponCounterFN.init();
                    }
                });
            }

            if(utils.detectEl($('.page-product-detail')[0])){
                $.cachedScript(extJSPath + 'components/pdp.js').done(function(s, r) {
                    if(r == 'success'){
                        pdpControls.init();
                    }
                });
            }
            
            if(utils.detectEl($('#modal-add-new-address')[0]) || utils.detectEl($('#modal-guest-address')[0]) || utils.detectEl($('.page-payment')[0]) || utils.detectEl($('.page-cart')[0])){
                $.cachedScript(extJSPath + 'components/purchase/purchaseControls.js').done(function(script, textStatus) {
                    if(textStatus == 'success'){
                        purchaseControlsFN.init();
                    }
                });
            }
            
            if(utils.detectEl($('#deal-countdown')[0])){
                $.cachedScript(extJSPath + 'components/countdownCustom.js').done(function(script, textStatus) {
                    if(textStatus == 'success'){
                        dealCountdownFN.init();
                    }
                });
            }

            if(utils.detectEl($('input[data-mask]')[0])){
                $.cachedScript(extJSPath + 'components/cleaveCustom.js').done(function(script, textStatus) {
                    if(textStatus == 'success'){
                        inputMask.init();
                    }
                });
            }

            if(utils.detectEl($('#main-slider')[0])){
                $.cachedScript(extJSPath + 'components/mainSlider.js').done(function(s, r) {
                    if(r == 'success'){
                        mainSlider.init();
                    }
                });
            }

            if(utils.detectEl($('#main-slider')[0])){
                $.cachedScript(extJSPath + 'components/sliderVideo.js').done(function(script, textStatus) {
                    if(textStatus == 'success'){
                        sliderVideoFN.init();
                    }
                });
            }

            if(utils.detectEl($('.default-input')[0]) || utils.detectEl($('.select-list')[0]) || utils.detectEl($('.dropbox-container')[0]) ||  utils.detectEl($('[data-scroll-target]')[0])){
                $.cachedScript(extJSPath + 'components/elements.js').done(function(script, textStatus) {
                    if(textStatus == 'success'){
                        elements.init();
                    }
                });
            }

            if(utils.detectEl($('.quick-action-menu-project')[0])){
                $.cachedScript(extJSPath + 'components/quick-action-menu.js').done(function(script, textStatus) {
                    if(textStatus == 'success'){
                        quickActionMenu.init();
                    }
                });
            }

            if(utils.detectEl($('.page-games')[0])){
                $.cachedScript(extJSPath + 'components/games-landing.js').done(function(script, textStatus) {
                    if(textStatus == 'success'){
                        gamesLanding.init();
                    }
                });
            }

            if(utils.detectEl($('[data-fancybox]')[0])){
                $.cachedScript(extJSPath + 'fancybox.min.js');
            }

            if(utils.detectEl($('lottie-player')[0])){
                $.cachedScript(extJSPath + 'lottie-player@2.0.4.js');
            }
        });

        // SWIPER
        var swiperElem = scope.querySelectorAll('[data-swiper]'),
        swiperTrigger = function () {
            utils.forEach(swiperElem, function (index, elm) {
                var cls = 'swiper-activeted';
                if ( ! $(elm).hasClass(cls)) {
                    elm.classList.add(cls);
                    new MinusSwiper({ ID: elm });
                }
            });
        };

        if (swiperElem.length > 0){
            if(typeof MinusSwiper !== 'undefined'){
                swiperTrigger();
            }else{
                if(swiperJSPluginLoader.status == ''){
                    swiperJSPluginLoader.init(function(){
                        swiperTrigger();
                    });
                }
            }
        }
        
        // sliderVideo.js
        //sliderVideo.init();
        
        // Animate on Scroll
        if(isMobile)
            scrollEffector.init('.se-item', SITE_CONFIG.animations.mobile);
        else
            scrollEffector.init('.se-item', SITE_CONFIG.animations.desktop);

        const topElement = document.querySelector('.page-top');
        setTimeout(() => {
            topElement.classList.add('sr-only');
        }, 2000);

        $('#site-footer .btn-page-top').on('click', function(){
            utils.pageScroll({top: 0});
            
            topElement.focus();

            topElement.textContent = pageTopMsg || '';

            setTimeout(() => {
                topElement.textContent = '';
            }, 6000);
        });

        function setModalA11yState(event, isOpen) {
            var $modal = $(event.target);
            var modalId = $modal.attr('id');
            if (!modalId) return;

            var $button = $('[data-toggle="modal"][data-target="#' + modalId + '"]');
            if (!utils.detectEl($button) || !utils.detectEl($modal)) return;

            $button.attr('aria-expanded', isOpen ? 'true' : 'false');
            $modal.attr('aria-hidden', isOpen ? 'false' : 'true');

            var msgAttr = isOpen ? 'data-open-msg' : 'data-close-msg';
            var msg = $button.attr(msgAttr);

            if (typeof msg !== 'undefined' && msg) {
                var srDivId = 'sr_' + modalId + '_msg';
                var $srDiv = $('#' + srDivId);
                if ($srDiv.length) {
                   if ($srDiv.text() !== msg) {
                        $srDiv.text(msg);
                    }
                } else {
                    $srDiv = $('<div>', {id: srDivId, class: 'page-top sr-only', 'aria-live': 'assertive','aria-atomic': 'true', text: msg});
                    $modal.before($srDiv);
                }
            }
        }
         
        $(document).on('show.bs.modal', function (event) {
            setModalA11yState(event, true);
        });

        $(document).on('hidden.bs.modal', function (event) {
            setModalA11yState(event, false);
        });

        // Pikaday
        if(utils.detectEl($('[data-datepick]')[0])){
            var datepicker, dpConfig;

            $.cachedScript(extJSPath + 'pikaday.min.js').done(function(script, textStatus) {
                $('[data-datepick]').each(function(){
                    dpConfig = SITE_CONFIG.plugin.pikaday.sets[$(this).attr('data-datepick')];
                    dpConfig['field'] = this;

                    for(i in SITE_CONFIG.plugin.pikaday.defaults)
                        dpConfig[i] = SITE_CONFIG.plugin.pikaday.defaults[i];

                    datepicker = new Pikaday(dpConfig);
                });
            });
        }

        // Scrollable Tabs Selected
        var scrOl;
        $('.nav.scrollable-h').each(function(){
            if(utils.detectEl($('.active', this)[0])){
                scrOl = $('.active', this).position().left;
                $(this).scrollLeft(scrOl - 20);
            }
        });

        // Copy to Clipboard
        if(utils.detectEl($('[data-clipboard]')[0])){
            $('[data-clipboard]').on('click', function(){
                clipboardItem.init(this);
            });
        }

        // Event Detail Gallery
        if(utils.detectEl($('.swiper-gallery')[0]) && ! isMobile){
            var prn;
            $('.swiper-gallery .swiper-slide figure').on('click', function(){
                prn = $(this).parents('.gallery');
                $('body').addClass('gallery-opened');
                $('.swiper-container', prn).addClass('swiper-theme-light');
                $('.swiper-container', prn)[0].update();
                $('#overlay, .btn-gallery-close').off().on('click', function(){
                    $('body').removeClass('gallery-opened');
                    $('.swiper-container', prn).removeClass('swiper-theme-light');
                    $('.swiper-container', prn)[0].update();
                });
            }); 
        }

        // Top Stripe
        if(utils.detectEl($('#top-stripe')[0])){
            $('#top-stripe').on('close.bs.alert', function () {
                $('body').removeClass('top-stripe-opened');
            });
        }

        // Home Category Swiper
        if(utils.detectEl($('#category-swiper')[0])){
            if($('#category-swiper .swiper-slide').length < 5)
                $('#category-swiper').addClass('c-aligned');
        }

        // Order Cancel/Return
        if(utils.detectEl($('.ord-cancellation')[0])){
            var prn;
            $('.ocp-a > .radio input').on('change', function () {
                prn = $(this).parents('.ocp-row');
                $('.ocp-a.active', prn).removeClass('active');
                $(this).parents('.ocp-a').addClass('active');
            });
        }

        //dynamic iframe
        window.addEventListener('message', function(event) {
            document.querySelectorAll('.dynamic-iframe').forEach(iframe => {
                iframe.style.height = event.data + 'px';
            });
        });
        
    },
    init: function () {
        var _t = this;
        _t.initPlugins(document);
    },
};

new Main();

// dispatcher
function ON_READY() {
    // console.log('ON_READY bodyde belirlenen class');
    document.body.classList.remove('holding');
}
stage.addEventListener("CustomEvent", [{ type: 'EVENTS_ON_READY', handler: 'ON_READY' }]);

/* 
    populer products
*/
function ON_SWIPER_EVENT(o) {
    var ID = o['ID'],
        type = o['type'] || '';
    if (type == 'reachEnd') {
        setTimeout(function () {
            var wrp = ID.querySelector('.swiper-wrapper'),
                sld = wrp.querySelectorAll('.swiper-slide');
            utils.forEach(sld, function (i, ths) {
                ths.classList.remove('swiper-slide-active');
            });
            sld[sld.length - 1].classList.add('swiper-slide-active');
        }, 100);
    }

    /* 
        compare
    */
    var _ID = $(ID),
        k = _ID.attr('data-swiper') || '';
    if (k == 'compare' && type == 'slideChangeTransitionEnd') {
        var activePagination = _ID.find('.swiper-pagination-bullet-active').index() || 0;
        
        var pagination = $('#compare-all-features .swiper-container .swiper-pagination')
        .add( $('#compare-products .swiper-pagination')  )
        .add( $('.compare-top-panel .swiper-pagination')  );
        pagination
        .each(function(){
            var ths = $( this );
            ths.find('> span').eq( activePagination ).trigger('click');
        });
    }

    if (k == 'quick-categories' && type == 'slideChangeTransitionStart') {
        _ID.closest('.select-list-container').find('.list-dropbox').empty().removeClass('active');
    }
}

stage.addEventListener("CustomEvent", [{ type: 'SWIPER_ACTIVE_ELEMENT', handler: 'ON_SWIPER_EVENT' }]);

///////////////////////////// DISPATCHER YAPISI

/* 
    USAGE: 
    dispatcher({ type: 'LIST_LOADED', data: { ID: $( ID ) }  });
*/

var dispatcher = function (o) {
    o = o || {};
    var type = o['type'] || '',
        data = o['data'] || {};

    if (typeof stage !== 'undefined' && type != '')
        stage.dispatchEvent("CustomEvent", type, data);
};

/* 
    ex: 
    dispatcher({ type: 'LIST_LOADED', data: { ID: $( ID ) }  });


    data ile istediğin her turlu objeyi yollayabilirsin. Tab yapısında mesela ajx ile dolduktan sonra

    ajx(function(res){
        .
        .
        .
            dispatcher({ type: 'TAB_LOADED', data: { ID: $( ID ) }  });
    });

*/

function ON_TAB_LOADED( o ){
    /* 
        ajx tab pluginlerini burda tetikle
    */
    if(o['id'] == 'PDP_TAB_REVIEWS'){
        lazy.update();
        pdpControls.reviews.init();
    }
}
stage.addEventListener("CustomEvent", [{ type: 'TAB_LOADED', handler: 'ON_TAB_LOADED' }]);

/* Recomended İnsider Swiper Update */
function ON_RECOMENDED_PRODUCT_REPLACE( o ){
    o = o || {};
    var type = o.type || '';
    if( type == 'all' ){
        var target = $('.swiper-container');
        if( target.length > 0 ){
            target.each(function(){
                if( typeof $( this ).get(0).update !== 'undefined' ){
                    $( this ).get(0).update();
                }
            });
        }
    }
}
stage.addEventListener("CustomEvent", [{ type: 'RECOMENDED_PRODUCT_REPLACE', handler: 'ON_RECOMENDED_PRODUCT_REPLACE' }]);

/* PDP INSIDER UPDATE */ 
function ON_INSIDER_RECOMENDED_APPEND( o ){
    o = o || {};
    try {
        var type = o.type || '',
            target = $( o.target || null ),
            swiper = target.find('.swiper-container');
        if( swiper.length > 0 && typeof MinusSwiper !== 'undefined' ){
            if( !swiper.hasClass('swiper-activeted') ){
                swiper.addClass('swiper-activeted');
                new MinusSwiper({
                    ID: swiper[0]
                });
            }
        }
    } catch (error) {
        console.log('ON_INSIDER_RECOMENDED_APPEND ERROR', error);
    }
}
stage.addEventListener("CustomEvent", [{ type: 'INSIDER_RECOMENDED_APPEND', handler: 'ON_INSIDER_RECOMENDED_APPEND' }]);